var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex position-relative cursor-pointer",
      attrs: { "data-testid": "searchbar-league-item" },
      on: {
        mousedown: function ($event) {
          return _vm.onCardClick()
        },
      },
    },
    [
      _vm.league
        ? _c(
            "v-container",
            { staticClass: "px-1 pb-1 pt-1", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "px-3 py-0 d-flex justify-center align-center",
                      attrs: { cols: "2" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/" +
                            _vm.league.id +
                            ".png",
                          height: 28,
                          contain: "",
                        },
                        on: {
                          error: function ($event) {
                            return _vm.onImageLoadFailure($event)
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "pl-2 pr-0 py-0 d-flex flex-column justify-center",
                      attrs: { cols: "10" },
                    },
                    [
                      _c("div", { staticClass: "d-flex flex-column" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-center justify-space-between",
                          },
                          [
                            _c("div", { staticClass: "d-flex flex-grow-1" }, [
                              _c(
                                "span",
                                { staticClass: "body-2 primary--text" },
                                [_vm._v(_vm._s(_vm.league.name))]
                              ),
                            ]),
                            _vm._v(" "),
                            !_vm.$vuetify.breakpoint.smAndDown && _vm.league.cC
                              ? _c(
                                  "div",
                                  { staticClass: "d-flex align-center" },
                                  [
                                    _c("DriblabCountryFlag", {
                                      attrs: { iso: _vm.league.cC },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      { staticClass: "primary--text mx-2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              `iso.${_vm.league.cC.toUpperCase()}`
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }